
              import "_sentry-debug-id-injection-stub";
              import * as OriginalModule from "./potat/static/js/potat/common.index.ts";
              export default OriginalModule.default;
              export * from "./potat/static/js/potat/common.index.ts";